export function isNoise(text) {
    if (text.includes('[n::'))
        return true;
    if (text.includes('[h::'))
        return true;
    return false;
}
